import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';
import {TIMEOUT_STORE, TIMESTAMP_MULTIPLY} from 'util/constants';

module.exports = {
    createFetchParams: (startDate, endDate, filters) => {
        const params = {
            ci_class: filters.ciClass.join(','),
            operable: filters.operable,
            state:    filters.state
        };

        if (filters.state === 'all') {
            Object.assign(params, {
                start_date: Math.floor(startDate / TIMESTAMP_MULTIPLY),
                end_date:   Math.floor(endDate / TIMESTAMP_MULTIPLY)
            });
        }

        return params;
    },
    ...storeModuleFactory({
        name:               'monitoringObjectsId',
        endpoint:           endpoints.monitoring.objectsID,
        timeout:            TIMEOUT_STORE.TIMEOUT_STORE_SMALL,
        transformResultsFn: json => !json.results ? [] : json.results.map(item => ({
            objectClass: item.object_class,
            severity:    item.severity,
            totalEvents: item.total_events
        }))
    })
};



// WEBPACK FOOTER //
// ./src/modules/store/monitoringObjectsId.js